import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Container, Input, Row, Table } from 'reactstrap';
import { toast } from "react-toastify";
import _ from 'lodash';
import { FilterSelect, ServiceThreadSpinner } from '.';
import { api, filterHelpers } from '../utils';
import { confirmAlert } from "react-confirm-alert";

export default function ManageExceptionMachines() {
   const ALL_OPTS = { value: 0, label: "-- Select --" };
   const MACH_MODEL = { id: 0, isActive: true, machineId: 0, machineName: "", maxWeight: 99.99 };
   const [addList, setAvailableList] = useState([]);
   const [addMachine, setAddMachine] = useState(MACH_MODEL);
   const [addWgt, setAddWgt] = useState(0);
   const [editWgt, setEditWgt] = useState(0);
   const [machine, setMachine] = useState(MACH_MODEL);
   const [machList, setMachList] = useState([]);
   const [filters, setFilters] = useState([
      { filterName: "machine", value: ALL_OPTS },
      { filterName: "addMachine", value: ALL_OPTS }
   ]);
   const [spinExcept, setSpinExcept] = useState(true);

   useEffect(() => {
      runQuery();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   function AddExceptionMachine() {
      if (!addMachine || addMachine.machineId === 0) {
         toast.error("Please select a machine to be added");
         return;
      }
      if (!addMachine.maxWeight || addMachine.maxWeight <= 0) {
         toast.error("Please enter the maximum weight allowed when completing a record");
         return;
      }
      let pay = Object.assign({}, MACH_MODEL);
      pay.machineId = addMachine.machineId;
      pay.machineName = addMachine.machineName;
      pay.maxWeight = addWgt;
      SaveExceptionMachine(pay);
   }

   function DeleteMachine() {
      setSpinExcept(true);
      api.post(`Production/DeleteExceptionMachine/${machine.id}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Exception machine was successfully deleted.")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinExcept(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinExcept(false);
         });
   }

   function onAddChange(newFilterValue) {
      const addItm = _.find(addList, (x) => x.value === newFilterValue.value);
      const editItm = _.find(machList, (x) => x.value === 0);
      let newFilters = filterHelpers.getFilters(filters, {
         filterName: "addMachine",
         value: addItm,
      });
      newFilters = filterHelpers.getFilters(newFilters, {
         filterName: "machine",
         value: editItm,
      });
      setFilters(newFilters);

      if (newFilterValue.value === 0) {
         // Not adding, reset some stuff
         setAddWgt(0);
         setAddMachine(MACH_MODEL);
      }
      else {
         // Reset the edit site
         setEditWgt(0);
         setMachine(MACH_MODEL);

         // Get the selected machine
         setAddWgt(99.99);
         let changes = Object.assign({}, MACH_MODEL);
         changes.machineId = newFilterValue.value;
         changes.machineName = newFilterValue.label;
         changes.maxWeight = 99.99;
         setAddMachine(changes);
      }
   }

   function onMachineChange(newFilterValue) {
      const editItm = _.find(machList, (x) => x.value === newFilterValue.value);
      const addItm = _.find(addList, (x) => x.value === 0);
      let newFilters = filterHelpers.getFilters(filters, {
         filterName: "machine",
         value: editItm,
      });
      newFilters = filterHelpers.getFilters(newFilters, {
         filterName: "addMachine",
         value: addItm,
      });
      setFilters(newFilters);

      if (newFilterValue.value === 0) {
         // Not editing, reset some stuff
         setEditWgt(0);
         setMachine(MACH_MODEL);
      }
      else {
         // Reset the add machine
         setAddWgt(0);
         setAddMachine(MACH_MODEL);

         // Get the selected machine & set it up
         const d = _.find(machList, (x) => x.value === newFilterValue.value);
         setEditWgt(d.maxWeight);

         let changes = Object.assign({}, MACH_MODEL);
         changes.id = newFilterValue.value;
         changes.isActive = d.isActive;
         changes.machineId = d.machineId;
         changes.machineName = newFilterValue.label;
         changes.maxWeight = d.maxWeight;
         setMachine(changes);
      }
   }

   function onMachineUpdate() {
      if (!machine || machine.id === 0) {
         toast.error("Please select an exception machine to edit");
         return;
      }
      let payload = Object.assign({}, machine);
      payload.maxWeight = editWgt;
      SaveExceptionMachine(payload);
   }

   function runQuery() {
      setSpinExcept(true);
      api
         .fetch(`Production/LoadMachineExceptionLists`)
         .then((response) => {
            if (response.data.success) {
               const exList = _.concat([ALL_OPTS],
                  _.map(response.data.exceptions, (e) => ({
                     value: e.id,
                     label: e.machineName,
                     isActive: e.isActive,
                     machineId: e.machineId,
                     maxWeight: e.maxWeight
                  })));
               const avList = _.concat([ALL_OPTS],
                  _.map(response.data.machines, (m) => ({
                     value: m.id,     // this is the machineId, otherwise it would be 0
                     isActive: true,
                     machineId: m.id, // This is also machineId
                     label: m.name,
                     maxWeight: 99.99 // This is a default value
                  })));
               return { exList: exList, avList: avList };
            } else {
               toast.error(response.data.message);
            }
         })
         .then(({ exList, avList }) => {
            setMachList(exList);      // current exception machines
            setAvailableList(avList); // machines available to add
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            const addItm = _.find(addList, (x) => x.value === 0);
            const editItm = _.find(machList, (x) => x.value === 0);
            let newFilters = filterHelpers.getFilters(filters, {
               filterName: "addMachine",
               value: addItm,
            });
            newFilters = filterHelpers.getFilters(newFilters, {
               filterName: "machine",
               value: editItm,
            });
            setFilters(newFilters);
            setAddMachine(MACH_MODEL);
            setMachine(MACH_MODEL);
            setSpinExcept(false);
         });
   }

   function SaveExceptionMachine(payload) {
      setSpinExcept(true);
      api.post('Production/SaveExceptionMachine', payload)
         .then((response) => {
            if (response.data.success) {
               runQuery();
               toast.success("Exception machine saved successfully!")
            } else {
               setSpinExcept(false);
               toast.error(response.data.message);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            setSpinExcept(false);
            toast.error(error);
         });
   }

   const ShowDeleteModal = () => {
      if (!machine || machine.id === 0) {
         toast.error("Please select an exception machine to delete");
         return;
      }

      confirmAlert({
         title: "Confirm Deletion",
         message: `Are you sure you want to delete the ${machine.machineName} exception machine?`,
         buttons: [
            { label: "Yes", onClick: () => { DeleteMachine() } },
            { label: "No" }
         ]
      });
   }

   return (
      <Container fluid>
         <Row>
            <Col>
               <Fragment>
                  <ServiceThreadSpinner on={spinExcept}>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           <Table className="transparent-background my-0">
                              <tbody>
                                 {addList && addList.length ? (
                                    <tr>
                                       <td className="transparent-background data-cell noWrap h6 width115px">
                                          Available:
                                       </td>
                                       <td className="transparent-background width500px">
                                          <FilterSelect
                                             filterName="addMachine"
                                             options={addList}
                                             value={filterHelpers.getValue(filters, "addMachine")}
                                             onChangeCallback={e => onAddChange(e)}
                                          />
                                       </td>
                                       <td className="transparent-background data-cell"></td>
                                    </tr>
                                 ) : null}
                                 {machList && machList.length ? (
                                    <tr>
                                       <td className="transparent-background data-cell noWrap h6 width115px">
                                          Exceptions:
                                       </td>
                                       <td className="transparent-background width500px">
                                          <FilterSelect
                                             filterName="machine"
                                             options={machList}
                                             value={filterHelpers.getValue(filters, "machine")}
                                             onChangeCallback={e => onMachineChange(e)}
                                          />
                                       </td>
                                       <td className="transparent-background data-cell"></td>
                                    </tr>
                                 ) : null}
                              </tbody>
                           </Table>
                        </Col>
                     </Row>

                     {addMachine && addMachine.machineId > 0 ? (
                        <div>
                           <Row className="px-0 py-0">
                              <Table className="transparent-background data-table">
                                 <tbody>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td colSpan={2} className="transparent-background data-cell noWrap h6">
                                          Machine: {addMachine.machineName}
                                       </td>
                                       <td className="transparent-background data-cell"></td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell noWrap h6 width115px">
                                          Max Weight:
                                       </td>
                                       <td className="transparent-background data-cell">
                                          <Input
                                             type="number"
                                             className="no-spinner width115px"
                                             value={addWgt || 99.99}
                                             maxLength="6"
                                             onChange={(e) => {
                                                if (e.target.value.match(/^\d{1,3}(\.\d{0,2})?$/)) // Up to 3 digits with 2 decimals allowed
                                                   setAddWgt(e.target.value);
                                             }}
                                          />
                                       </td>
                                       <td className="transparent-background data-cell"></td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td colSpan={2} className="transparent-background data-cell">
                                          <Button
                                             title="Add Machine"
                                             className="shredButtonExcel"
                                             onClick={() => AddExceptionMachine()}
                                          >
                                             Add Exception
                                          </Button>
                                       </td>
                                       <td className="transparent-background data-cell"></td>
                                    </tr>
                                 </tbody>
                              </Table>
                           </Row>
                        </div>
                     ) : null}

                     {machine && machine.id > 0 ? (
                        <div>
                           <Row className="px-0 py-0">
                              <Table className="transparent-background data-table">
                                 <tbody>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td colSpan={2} className="transparent-background data-cell noWrap h6">
                                          Machine: {machine.machineName}
                                       </td>
                                       <td className="transparent-background data-cell"></td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell noWrap h6 width115px">
                                          Max Weight:
                                       </td>
                                       <td className="transparent-background data-cell width185px">
                                          <Input
                                             type="number"
                                             className="no-spinner"
                                             value={editWgt || 99.99}
                                             maxLength="6"
                                             onChange={(e) => {
                                                if (e.target.value.match(/^\d{1,3}(\.\d{0,2})?$/)) // Up to 3 digits with 2 decimals allowed
                                                   setEditWgt(e.target.value);
                                             }}
                                          />
                                       </td>
                                       <td className="transparent-background data-cell"></td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td colSpan={2} className="transparent-background data-cell">
                                          <Button
                                             title="Update"
                                             className="shredButton"
                                             onClick={() => onMachineUpdate()}
                                          >
                                             Update
                                          </Button>
                                          &nbsp;&nbsp;&nbsp;
                                          <Button
                                             title="Delete"
                                             className="shredButton"
                                             onClick={() => ShowDeleteModal()}
                                          >
                                             Delete
                                          </Button>
                                       </td>
                                       <td colSpan={2} className="transparent-background data-cell"></td>
                                    </tr>
                                 </tbody>
                              </Table>
                           </Row>
                        </div>
                     ) : null}

                  </ServiceThreadSpinner>
               </Fragment>
            </Col>
         </Row>
      </Container >
   );
}
